export default function preventDefaultEvent (event) {
  event.preventDefault()
}
